"use client";

import React from "react";
import {useTranslation} from "react-i18next";
import Input from "@/components/library/Input";
import {
   type DirectoSmsFormErrors,
   type DirectoSmsFormValues,
} from "@/utils/integrations/smsValidation";

interface DirectoSmsFieldsProps {
   values: DirectoSmsFormValues;
   errors: DirectoSmsFormErrors;
   onChange: (field: keyof DirectoSmsFormValues) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function DirectoSmsFields({values, errors, onChange}: DirectoSmsFieldsProps) {
   const {t} = useTranslation("partners");

   return (
      <Input
         id="sms-directo-from-phone"
         type="text"
         name="fromPhoneNumber"
         label={t("smsIntegration.form.fromPhoneNumber")}
         placeholder={t("smsIntegration.form.phoneNumberPlaceholder")}
         value={values.fromPhoneNumber}
         onChange={onChange("fromPhoneNumber")}
         error={!!errors.fromPhoneNumber}
         helperText={errors.fromPhoneNumber}
         data-testid="sms-directo-from-phone"
      />
   );
}
